import { useEffect } from "react";
import { Link } from "react-router-dom";
import { useSearchParams, useNavigate } from "react-router-dom";
import { getCustomerInfoKickoutPage } from "services/get-customerInfoKickoutPage";
import { useSetRecoilState } from "recoil";
import { overlayState } from "atoms";
import "components/CustomerInfoKickoutPage/customerInfoKickoutPage.scss";

function CustomerInfoKickoutPage() {
  const setShowOverlay = useSetRecoilState(overlayState);
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const locationId: string | null = searchParams.get("locationId");
  const reason: string | null = searchParams.get("reason");

  useEffect(() => {
    const fetchKickoutPage = async () => {
      setShowOverlay(true);
      if (locationId) {
        await getCustomerInfoKickoutPage();
        setShowOverlay(false);
      } else {
        // navigate("/");
        setShowOverlay(false);
      }
    };
    fetchKickoutPage();
  }, [locationId, navigate, setShowOverlay]);

  useEffect(() => {
    window.scroll(0, 0);
  });

  const activateChatClick = () => {
    const chatClickElement = document.querySelector(".helpButtonEnabled") as HTMLElement;

    if (chatClickElement) {
      chatClickElement.click();
    }
  };

  const pushToServiceRequestPage = () => {
    const searchParams = new URLSearchParams();
    searchParams.set("locationId", !locationId ? "0" : locationId);
    searchParams.set("reason", reason ?? "");

    navigate("/service-request?" + searchParams.toString(), {
      state: { locationId: locationId, reason: reason },
    });
  };

  const setReasonMessage = (reason: string | null) => {
    if (reason === "chesnee_address") {
      return (
        <div className="row mb-5 text-center">
          <h4 className="mt-5">
            We’re sorry, but online shopping is not available for your address at this time. Please contact our support team for further assistance.
            Otherwise,{" "}
            <span className="service-request" onClick={() => pushToServiceRequestPage()}>
              click here
            </span>{" "}
            to submit your information.
          </h4>
          <h4 className="mt-3">
            Call <a href="tel:888-403-2667">888-403-2667</a>
          </h4>
          <h3>or</h3>
          <h3>
            <button className="chat-now-button" onClick={() => activateChatClick()}>
              Chat Now
            </button>
          </h3>
        </div>
      );
    } else if (reason === "dsl_only") {
      return (
        <div>
          <div className="row d-flex w-100 mt-5">
            <div className="text-center">
              <h4>We currently have DSL services at your location. We need to verify the speeds available before we can proceed.</h4>
              <h4>
                Please{" "}
                <span className="service-request" onClick={() => pushToServiceRequestPage()}>
                  click here
                </span>{" "}
                to submit your information.
              </h4>
            </div>
            <div className="text-end mb-5 mt-5">
              <Link to="/" className="btn btn-primary btn-sm">
                Return to Address Search
              </Link>
            </div>
          </div>
        </div>
      );
    } else if (reason === "field_check") {
      return (
        <div>
          <div className="row d-flex w-100 mt-5">
            <div className="text-center">
              <h4>
                This appears to be a new address or one we have not previously serviced. To help us ensure we provide the best options for you, please
                <span className="service-request" onClick={() => pushToServiceRequestPage()}>
                  &nbsp;click here
                </span>{" "}
                to submit your information. Thank you for your patience!
              </h4>
            </div>
            <div className="text-end mb-5 mt-5">
              <Link to="/" className="btn btn-primary btn-sm">
                Return to Address Search
              </Link>
            </div>
          </div>
        </div>
      );
    } else {
      return (
        <div>
          <div className="row d-flex w-100">
            <div className="text-center">
              <h4>We need a little more information about your location to verify available services.</h4>
              <h4>
                Otherwise,{" "}
                <span className="service-request" onClick={() => pushToServiceRequestPage()}>
                  click here
                </span>{" "}
                to submit your information.
              </h4>
            </div>
            <div className="text-end mb-5 mt-5">
              <Link to="/" className="btn btn-primary btn-sm">
                Return to Address Search
              </Link>
            </div>
          </div>
        </div>
      );
    }
  };

  return <div className="customer-info-kickout-container">{setReasonMessage(reason)}</div>;
}

export default CustomerInfoKickoutPage;
